import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useMutation } from 'react-query';
import { yupErrorMsg } from '../../../components/atoms/const';
import api from '../../../components/api';

interface UpdatePassRes {
  'token': string;
}

function useUpdatePassword() {
  const [searchParams] = useSearchParams();
  console.log(searchParams.get('token'));
  const navigate = useNavigate();
  const navigateToLogin = () => {
    navigate('/login');
  };

  React.useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      navigate('/login', { replace: true });
    }
  }, []);

  /* state management for react query fetch management */
  const { isLoading, mutate: updatePass } = useMutation(api.auth.postUpdatePassword, {
    onMutate: (x) => console.log('onMutate', x),
    onSuccess: (res) => {
      console.log('login result', res);
      const resData: UpdatePassRes | undefined = res?.data?.data;
      if (resData) {
        sessionStorage.setItem('token', resData.token);
        navigate('/login');
      }
    },
    onError: (err: Error) => console.log('err', err.message),
  });

  /* form validation */
  /* change required function for showing error massage like you want */
  const yupSchema = yup.object({
    password: yup.string().matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
      yupErrorMsg.PASSWORD_INCORRECT_FORMAT,
    ).required(yupErrorMsg.PASSWORD_EMPTY),
    confirmPassword: yup.string().oneOf([yup.ref('password'), null], yupErrorMsg.PASSWORD_NOT_MATCH).required(yupErrorMsg.CONFIRM_PASS_EMPTY),
  });

  /* form handler */
  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: '',
    },
    validationSchema: yupSchema,
    onSubmit: (values) => {
      console.log('Token Url: ', searchParams.get('token'));
      updatePass({
        password: values.confirmPassword,
        token: searchParams.get('token')!,
      });
    },
  });

  /* get result from hitting login API */

  return {
    navigateToLogin, formik, isLoading,
  };
}

export default useUpdatePassword;
